import React, { Component } from 'react';
import { Translate } from 'react-redux-i18n';

class Item extends Component {
  render() {
    const { changeTab, name, isActive, isLock } = this.props;

    return (
      <li className="nav-item m-tabs__item" onClick={changeTab}>
        <a
          href="#"
          className={`nav-link m-tabs__link ${isActive && 'active'}`}
          style={{ height: 'auto', lineHeight: 'unset' }}
        >
          <Translate value={name} />
          {isLock && (
            <i
              style={{ fontSize: 10, marginLeft: 3 }}
              className="icon-padlock"
            />
          )}
        </a>
      </li>
    );
  }
}

Item.defaultProps = {
  isLock: false,
};

export default Item;
